import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-text-slate-500 tw-text-sm" }

import { computed, ref } from "vue"
  import { QSelect } from "quasar"
  
  import { useAuthStore } from "src/stores/auth-store";
 
  
export default /*#__PURE__*/_defineComponent({
  __name: 'DealershipSelect',
  props: {
    modelValue: {
      type: String as () => string | null,
      default: null,
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: '400px'
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const authStore = useAuthStore();

  const props = __props

  const value = computed<string | null>({
    get() {
      if (props.modelValue) {
        return props.modelValue.toString()
      }
      else {
        return null
      }
    },
    set(value: string | null) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit

  const dealershipSelect = ref<QSelect | null>(null);
  function validate(){
    return dealershipSelect.value!.validate();
  }
  __expose({ validate })

  const dealers = ref(authStore.selectedDealers ? authStore.selectedDealers.map(d => ({ label: d.name, value: d.affiliateUserId.toString() })) : []);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(QSelect), {
    modelValue: value.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    options: dealers.value,
    ref_key: "dealershipSelect",
    ref: dealershipSelect,
    rules: [val => (!!val) || 'Required'],
    "emit-value": "",
    "bg-color": "white",
    "popup-content-class": "tw-text-sm limit-dd-height",
    class: _normalizeClass(!dealershipSelect.value?.hasError ? 'tw-shadow-sm' : ''),
    "dropdown-icon": "mdi-chevron-down",
    "map-options": "",
    placeholder: "Select a dealership",
    "data-cy": "dealershipSelect",
    outlined: "",
    dense: "",
    style: _normalizeStyle({ maxWidth: props.maxWidth }),
    disable: __props.disabled,
    "data-clarity-unmask": "true"
  }, {
    selected: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(dealers.value.find(t => t.value == value.value)?.label), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "options", "rules", "class", "style", "disable"]))
}
}

})